import React from 'react';
import '../../../../../sass/apps/commerce/desktop/upgrade_information_content/compare_products.scss';

const CompareProductsOrg = (props) => (
  <table className="compare-products">
    <tbody>
      <tr className="compare-products__headings">
        <th className="compare-products__heading compare-products__first-heading" />
        <th className="compare-products__heading compare-products__middle-heading">
          <div className="rel">
            <span id="days7">{props.products[2].name}</span>
          </div>
        </th>
        <th className="compare-products__heading compare-products__middle-heading">
          <div className="rel">
            <span id="days14">{props.products[1].name}</span>
          </div>
        </th>
        <th className="compare-products__heading compare-products__middle-heading compare-products__forth-heading">
          <div className="rel">
            <span id="days28">{props.products[0].name}</span>
          </div>
        </th>
        <th className="compare-products__heading compare-products__last-heading" />
      </tr>
      <tr>
        <td className="compare-products__row-heading">Early Bird Access</td>
        <td className="compare-products__cell">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
        <td className="compare-products__cell">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
        <td className="compare-products__cell">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
      </tr>
      <tr>
        <td className="compare-products__row-heading">Bold Advertising</td>
        <td className="compare-products__cell">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
        <td className="compare-products__cell">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
        <td className="compare-products__cell">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
      </tr>
      <tr>
        <td className="compare-products__row-heading">Pause Your Upgrade</td>
        <td className="compare-products__cell">
          <span className="compare-products__icon compare-products__icon--cross">
            <i className="far fa-times" aria-hidden></i>
            <span className="compare-products__icon-text">No</span>
          </span>
        </td>
        <td className="compare-products__cell">
          <span className="compare-products__icon compare-products__icon--cross">
            <i className="far fa-times" aria-hidden></i>
            <span className="compare-products__icon-text">No</span>
          </span>
        </td>
        <td className="compare-products__cell">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
      </tr>
      <tr>
        <td className="compare-products__row-heading compare-products__spacer-no-bottom-border">
          <span>Success Guarantee</span>
          <span className="compare-products__heading-extended">
            If you&#39;re not successful, we&#39;ll give you another 4 weeks
            free.
          </span>
        </td>
        <td className="compare-products__cell compare-products__spacer-no-bottom-border">
          <span className="compare-products__icon compare-products__icon--cross">
            <i className="far fa-times" aria-hidden></i>
            <span className="compare-products__icon-text">No</span>
          </span>
        </td>
        <td className="compare-products__cell compare-products__spacer-no-bottom-border">
          <span className="compare-products__icon compare-products__icon--cross">
            <i className="far fa-times" aria-hidden></i>
            <span className="compare-products__icon-text">No</span>
          </span>
        </td>
        <td className="compare-products__cell compare-products__spacer-no-bottom-border">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
      </tr>
      <tr className="compare-products__row-costs">
        <td className="compare-products__row-heading">Cost</td>
        <td className="compare-products__price">
          {`${props.currencySymbol}${props.products[2].price}`}
        </td>
        <td className="compare-products__price">
          {`${props.currencySymbol}${props.products[1].price}`}
        </td>
        <td className="compare-products__price">
          {`${props.currencySymbol}${props.products[0].price}`}
        </td>
      </tr>
      <tr className="compare-products__row-costs">
        <td className="compare-products__row-heading">Saving</td>
        <td className="compare-products__price">&ndash;</td>
        <td className="compare-products__price">
          <strong>{`${props.currencySymbol}${(
            2 * props.products[2].price -
            props.products[1].price
          ).toFixed(2)}`}</strong>
        </td>
        <td className="compare-products__price">
          <strong>{`${props.currencySymbol}${(
            4 * props.products[2].price -
            props.products[0].price
          ).toFixed(2)}`}</strong>
        </td>
      </tr>
    </tbody>
  </table>
);
const CompareProductsExp = (props) => (
  <table className="compare-products">
    <tbody>
      <tr className="compare-products__headings">
        <th className="compare-products__heading compare-products__first-heading" />
        <th className="compare-products__heading compare-products__middle-heading">
          <div className="rel">
            <span id="days14">{props.products[1].name}</span>
          </div>
        </th>
        <th className="compare-products__heading compare-products__middle-heading compare-products__forth-heading">
          <div className="rel">
            <span id="days28">{props.products[0].name}</span>
          </div>
        </th>
        <th className="compare-products__heading compare-products__last-heading" />
      </tr>
      <tr>
        <td className="compare-products__row-heading">Early Bird Access</td>
        <td className="compare-products__cell">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
        <td className="compare-products__cell">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
      </tr>
      <tr>
        <td className="compare-products__row-heading">Bold Advertising</td>
        <td className="compare-products__cell">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
        <td className="compare-products__cell">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
      </tr>
      <tr>
        <td className="compare-products__row-heading">Pause Your Upgrade</td>
        <td className="compare-products__cell">
          <span className="compare-products__icon compare-products__icon--cross">
            <i className="far fa-times" aria-hidden></i>
            <span className="compare-products__icon-text">No</span>
          </span>
        </td>
        <td className="compare-products__cell">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
      </tr>
      <tr>
        <td className="compare-products__row-heading compare-products__spacer-no-bottom-border">
          <span>Success Guarantee</span>
          <span className="compare-products__heading-extended">
            If you&#39;re not successful, we&#39;ll give you another 4 weeks
            free.
          </span>
        </td>
        <td className="compare-products__cell compare-products__spacer-no-bottom-border">
          <span className="compare-products__icon compare-products__icon--cross">
            <i className="far fa-times" aria-hidden></i>
            <span className="compare-products__icon-text">No</span>
          </span>
        </td>
        <td className="compare-products__cell compare-products__spacer-no-bottom-border">
          <span className="compare-products__icon">
            <i className="far fa-check" aria-hidden></i>
            <span className="compare-products__icon-text">Yes</span>
          </span>
        </td>
      </tr>
      <tr className="compare-products__row-costs">
        <td className="compare-products__row-heading">Cost</td>
        <td className="compare-products__price">
          {`${props.currencySymbol}${props.products[1].price}`}
        </td>
        <td className="compare-products__price">
          {`${props.currencySymbol}${props.products[0].price}`}
        </td>
      </tr>
      <tr className="compare-products__row-costs">
        <td className="compare-products__row-heading">Saving</td>
        <td className="compare-products__price">
          <strong>{`${props.currencySymbol}${(
            2 * props.products[2].price -
            props.products[1].price
          ).toFixed(2)}`}</strong>
        </td>
        <td className="compare-products__price">
          <strong>{`${props.currencySymbol}${(
            4 * props.products[2].price -
            props.products[0].price
          ).toFixed(2)}`}</strong>
        </td>
      </tr>
    </tbody>
  </table>
);

const CompareProducts = (props) => {
  let hide_one_week_option = false;
  if (props.experiments && props.experiments.hide_one_week_option_experiment) {
    hide_one_week_option = props.experiments.hide_one_week_option_experiment;
  }
  return hide_one_week_option ? (
    <CompareProductsExp
      products={props.products}
      currencySymbol={props.currencySymbol}
    />
  ) : (
    <CompareProductsOrg
      products={props.products}
      currencySymbol={props.currencySymbol}
    />
  );
};

export default CompareProducts;
